import React, { useContext, useEffect, useReducer, useState } from "react";
import { setCurrentHomePage, setExternalSignIn, setGoHome, setLoader, setLoaderClosed } from "../../action/homeAction";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { sendAnalytics } from "../../../action/homeAction";
import { withTranslation } from "react-i18next";
import { CMSPath, globalIV, globalSalt } from "../../../config/constant";
import { connect } from "react-redux";
import { currentWidget, popupOpenClose, setHotelSelectionAfterLoginState, setShowAutoLoginPopup, setShowCustomPopup } from "../../../action/action";
import { MyContext } from ".";
import { getVredStayData } from "../../../action/the_know";
import moment from "moment";
import { handleLocationSelect, isUserLoggedin, isUserPreCheckedin } from "../hotelSelector/hotelSelector";
import { getHotelList } from "../../../action/hotelSelector";
import { toBool } from "../../JS/utility";
import { inAppBrowser } from "../../JS/inAppBrowser";

import clientConfigApi from "../../../../src/config/config"
import { AesUtil } from "../../../JS/AesUtil";
import { checkIsCheckinDone_callFetchBooking, isPossibleCheckinDone, isPossiblePreCheckinOpened, mapPmsPropertyCodeToHotelData, stayReservationPossibleStatus, userAutoLoginUsingTheKnow } from "./helper";
import { bookVirginListAtTabClickKeys, theKnowKeys } from "../../../config/layout2constant";
import { setCurrentTabNavItemList } from "../../action/action";
import Loader from "../../UI/loader";


const MyStayPage = (props) => {

    const { t } = props;
    const { dispatchCurrentPage, IPossiblePages, apiData, dispatchApiData, IApiData , getMyStayData } = useContext(MyContext)
    const [isLoading, setIsLoading]=useState(false);  
    const [staysData, setStaysData]= useState(null);
    const [shouldShowUpcomingData, setShouldShowUpcomingData]= useState(true);


    const checkInAtSelectedLocation = (hotelData, stay, lastName) =>{
            console.log("inside checkInAtSelectedLocation")
            let checkInAuthToken = {
                lastName,
                bookingNumber:stay.pms_confirmation_number,
                checkinDate :stay.arrival
            } 

            let aesUtil = new AesUtil(128, 1000);

            const redirectInfo= {
                appPath : "/checkin/id",
                checkInAuthToken : aesUtil.encrypt( globalSalt, globalIV, "1234567891234567", `${JSON.stringify(checkInAuthToken)}`)
            }       
            sessionStorage.setItem("theKnowReservationRedirectForCheckIn",true)
            sessionStorage.setItem("redirectInfo", JSON.stringify(redirectInfo));
            // props.setGoHome(true);
            setTimeout(()=>{
                handleLocationSelect(props, hotelData, false, ()=>{}, true );
            },100)

    }

    const goToSpecificLocation = (hotelData, stay, lastName) =>{
        console.log("inside goToSpecificLocation")

        const current_hotel_code = (localStorage.getItem("clientId") || sessionStorage.getItem("clientId") || process.env.REACT_APP_CLIENT_CONFIG || "").replace("GJ_", "").toUpperCase();
        if(hotelData.hotelPropertyKey==current_hotel_code ){
            props.closeOrderPopUp(true, "You are already at same location.");
            return;
        }

        const redirectInfo= {
            appPath : ""
        }       
        sessionStorage.setItem("redirectInfo", JSON.stringify(redirectInfo));
       
        setTimeout(()=>{
            handleLocationSelect(props, hotelData, false, ()=>{}, false );
        },100)
    }
  
    const openModifyingLink=(hotelData, stay)=>{
        let link= ( hotelData && hotelData.hotelMetaData && hotelData.hotelMetaData.bookingUrl && hotelData.hotelMetaData.bookingUrl.replace("step-1","modify")) || "";
        link= link + "?email=" + apiData.STAYS.data.profile.email + "&reservation=" + stay.confirmation_number;

         inAppBrowser(link, props, true, { displayName: "Modify link", dontSetCurrentWidget: true, isTheKnowModifyReservationLink:true, modifyIabBackCalled })
    }

    const modifyIabBackCalled = async () =>{
        console.log("modifyIabBackCalled")
        props.setLoader(true, "", true);
        await getMyStayData(true);
        props.setLoader(false)
    }


    const redirectToBookTab =()=>{
        let bookVirginTab = props.footerTabList && props.footerTabList.find((item) => {
            return bookVirginListAtTabClickKeys.includes(item.uniqueKey.toLowerCase())
        });

        if (bookVirginTab) {
            props.setCurrentHomePage(bookVirginTab);

            console.log("this.props.footerTabList", bookVirginTab)
            props.widgetList.map((item) => {
                if (item.uniqueKey === bookVirginTab.uniqueKey || item.uniqueKey === bookVirginTab.tabName.replace(/ /g, '').toLowerCase()) {
                    props.setCurrentTabNavItemList();
                    props.setCurrentTabNavItemList(item.widgets);
                }
            })
            props.currentWidget({});
        }
    }

    const shouldStayShowCheckInButton =(stay,hotelData)=>{
        if(!hotelData ||  JSON.stringify(hotelData)=='{}' )return false;

        const master_hotel_code = process.env.REACT_APP_CLIENT_CONFIG.replace("GJ_", "").toUpperCase();
        const current_hotel_code = (localStorage.getItem("clientId") || sessionStorage.getItem("clientId") || process.env.REACT_APP_CLIENT_CONFIG || "").replace("GJ_", "").toUpperCase();
        // if(hotelData.hotelPropertyKey==current_hotel_code && master_hotel_code!=current_hotel_code){
        //     if( isUserLoggedin() || isUserPreCheckedin()){
        //         return false;
        //     }
        // }

        // if(hotelData.isBetaHotel) return false;

        // date contraint here
        if(!isPossiblePreCheckinOpened(stay.arrival))return false;

        return true;
    }

    
    // const startFlow= async()=>{
    //     setIsLoading(true);

    //     const nonPastStays=  apiData.STAYS.data.stay.filter((stay)=>{return new Date(stay.departure) >= new Date(props.serverTimeDate.split("T")[0])});
        
    //     setStaysData(nonPastStays);
    //     setIsLoading(false);
    // }

    useEffect(async ()=>{
       
 
        await getMyStayData();
        // if( apiData.STAYS.data) {
        //     console.log("going for startFlow -> staypage ")
        //     startFlow();
        // } 
        // userAutoLoginUsingTheKnow(props);

    },[apiData.STAYS])

    useEffect(()=>{
        if( apiData.STAYS.data) {
            let stayToBeShown;

            const doesPassUpcomingConstraint = (stay)=>{
                if( stay.reservation_status_description == stayReservationPossibleStatus.CHECKED_OUT) return false;

                return new Date(stay.departure) >= new Date(props.serverTimeDate.split("T")[0]) 
            }
            
            if(shouldShowUpcomingData){
                stayToBeShown= apiData.STAYS.data.stay.filter((stay)=>{return doesPassUpcomingConstraint(stay) });
        
            }else{
                stayToBeShown=  apiData.STAYS.data.stay.filter((stay)=>{return !doesPassUpcomingConstraint(stay) });
                stayToBeShown = stayToBeShown.sort((a,b)=> new Date(b.arrival).getTime() - new Date(a.arrival).getTime());
        
            }
            console.log("staysData stayToBeShown:", stayToBeShown )
            setStaysData(stayToBeShown);
        }
       
    },[apiData.STAYS, shouldShowUpcomingData])

    useEffect(()=>{
        if(isLoading || apiData.STAYS.isFetching){
            props.setLoader(true, "", true);
        }else{
            props.setLoader(false);
        }
    },[isLoading, apiData.STAYS.isFetching ])
   
    return (
        <>
            <div class="mystay-page">
              
            <div class="toggle" onClick={()=>{setShouldShowUpcomingData(!shouldShowUpcomingData)}}>
                <div class={`${shouldShowUpcomingData && "selected"}`}>
                Upcoming
                </div>
                <div  class={`${!shouldShowUpcomingData && "selected"}`} >
                 Past
                </div>
            </div>

            {
                !apiData.STAYS.isFetching && !isLoading && staysData &&
                (    
                    <div class="content" >
                    
                  { 
                   staysData.length > 0 ?   
                             <>
                             {
                               shouldShowUpcomingData ?
                               <> 
                               <div class="tile-selection-text">
                                <div class="tile-selection-heading">UPCOMING STAYS</div>
                                <div class="tile-selection-desc">Wherever you're headed, we hope to see you there.</div>
                                </div>
                                <div class="functional-widgets">

                                    {
                                        
                                        staysData.map((stay)=>{
                                                    const hotelData= mapPmsPropertyCodeToHotelData(stay.pms_property_code,  props.location_data && props.location_data.payload);
                                                    console.log("hotel data for pms_property_code ",hotelData, stay.pms_property_code )

                                                    let imgSrc="";
                                                    if(hotelData && hotelData.hotelMetaData && hotelData.hotelMetaData.knowStayTileImage){
                                                        imgSrc =  hotelData.hotelMetaData.knowStayTileImage;
                                                    } else if (hotelData &&   hotelData.hotelBannerImageUrl){
                                                        imgSrc= hotelData.hotelBannerImageUrl;
                                                    }
                                                    

                                                    return shouldStayShowCheckInButton(stay, hotelData) 
                                                    ? <div class="tile">
                                                        <div class="container">
                                                            <div class="upcoming-checkin-container">
                                                                 <img class="upcoming-checkin" src={imgSrc}/>
                                                            </div>
                                                            <div class="details">
                                                                <div class="place">{stay.pms_property_name}</div>
                                                                <div class="date">{`${moment(stay.arrival).format(props.dateFormat.toUpperCase())} - ${moment(stay.departure).format(props.dateFormat.toUpperCase())}`}</div>
                                                                <div class="date">{stay.confirmation_number}</div>
                                                            </div>
                                                        </div> 
                                                        <div class="ctrl">
                                                            {
                                                                stay.reservation_status_description== stayReservationPossibleStatus.CHECKED_IN 
                                                                ?  <button class="primary checked-in" onClick={()=>goToSpecificLocation(hotelData, stay, apiData.STAYS.data.profile.last_name )}>Already Checked In</button>
                                                                :  <button class="primary" onClick={()=>checkInAtSelectedLocation(hotelData, stay, apiData.STAYS.data.profile.last_name )}>Check In</button>

                                                            }
                                                        </div>
                                                    </div>
                                                    :
                                                    <>
                                                        <div class={`tile-selection tile-container`} onClick={()=>{openModifyingLink(hotelData, stay)}}>
                                                            <div class="tile-selection-img">
                                                                <img src={imgSrc}></img>
                                                            </div>
                                                            <div class="tile-selection-text">
                                                                <div class="tile-selection-heading">{stay.pms_property_name}</div>
                                                                <div class="tile-selection-desc">{`${moment(stay.arrival).format(props.dateFormat.toUpperCase())} - ${moment(stay.departure).format(props.dateFormat.toUpperCase())}`}</div>
                                                                <div class="tile-selection-desc">{stay.confirmation_number}</div>
                                                            </div>
                                                        </div>
                                                    </>
                                                                            

                                            })
                                                
                                    }
                                    
                                </div>
                                </>
                               : <> 
                                     <div class="tile-selection-text">
                                    <div class="tile-selection-heading">PAST STAYS</div>
                                    <div class="tile-selection-desc">A look back at your stays—because good times are worth repeating.</div>
                                    </div>
                                    <div class="functional-widgets">

                                        {
                                        
                                            staysData.map((stay)=>{
                                                        const hotelData= mapPmsPropertyCodeToHotelData(stay.pms_property_code,  props.location_data && props.location_data.payload);
                                                        console.log("hotel data for pms_property_code ",hotelData, stay.pms_property_code )
                                                        const imgSrc= hotelData.hotelBannerImageUrl || "";
                                                        
                                                        return  <>
                                                        <div class={`tile-selection tile-container`}
                                                        //  onClick={()=>{openBookLink(hotelData)}}
                                                         >
                                                             <div class="tile-selection-img">
                                                                    <img src={imgSrc}></img>
                                                                </div>
                                                                <div class="tile-selection-text">
                                                                    <div class="tile-selection-heading">{stay.pms_property_name}</div>
                                                                    <div class="tile-selection-desc">{`${moment(stay.arrival).format(props.dateFormat.toUpperCase())} - ${moment(stay.departure).format(props.dateFormat.toUpperCase())}`}</div>
                                                                    <div class="tile-selection-desc past">{stay.confirmation_number}</div>
                                                                </div>
                                                            </div>
                                                        </>
                                                                                

                                                })
                                                     
                                                    
                                        }
                                        
                                    </div>
                                </>
                               }
                               
                            </>
                        :<>
                         <div class="no-data" >
                                        <div class="img">
                                            <img src={shouldShowUpcomingData?t("the_know.my_stay_page.no_stays.upcoming.hero_img_url"):t("the_know.my_stay_page.no_stays.past.hero_img_url")}/>
                                        </div>
                                        <div class="text">
                                            <div class="heading">{shouldShowUpcomingData?t("the_know.my_stay_page.no_stays.upcoming.heading"):t("the_know.my_stay_page.no_stays.past.heading")}</div>
                                            <div class="subheading">{shouldShowUpcomingData?t("the_know.my_stay_page.no_stays.upcoming.subheading"):t("the_know.my_stay_page.no_stays.past.subheading")}</div>
                                        </div>
                                        <div class="button primary" onClick={redirectToBookTab}>{t("the_know.my_stay_page.no_stays.button_txt")}</div>
                         </div>
                        </>
                    }

                    </div>
                    
                )
                
            }
            </div>
        </>
    )
}

const getTabs = (duration) => {
    if (duration && duration.tabDetails && duration.tabDetails.length > 0) {
        return duration.tabDetails
    } else { return false }
}


const mapStateToProps = (state) => {
    return {
        externalSignIn: state.store2.externalSignIn,
        selectedHomePage: state.store2.currentHomePage,
        showNewHeader: state.store2.showNewHeader,
      
        widgetList: state.store2.sideNavBar.widgetList,
        notifications: state.store.home.gJnotifications,
        profile: state.store.home.currentDuration.brandingInfo.app ?
            state.store.home.currentDuration.brandingInfo.app.profileWidget : {},
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        bgImage: state.store.home.currentDuration.launcherBgImageUrl,
        guestName: state.store.home.guestDetails ?
            state.store.home.guestDetails.guestName : null,
        selfieVideo: state.store2.selfieVideo,
        menuColor: state.store.home.MenuColor,
        currentHomePageBeforeNotificationTab: state.store2.currentHomePageBeforeNotificationTab,
        currentHomePage: state.store2.currentHomePage,
        serverTimeDate: state.store.home.serverTimeDate.date,
        dateFormat: state.store.home.clientConfig.extraConfigParam
        ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
        : "",
        sessionToken: state.store.sessionToken,
        showFailScreen: state.store.failScreenconfig.showFailScreen,
        failScreenMessage1: state.store.failScreenconfig.failScreenMessage1,
        failScreenMessage2: state.store.failScreenconfig.failScreenMessage2,
        showClose: state.store.failScreenconfig.showClose,
        selectedList: state.store2.selectedList,
        roomAssistancePageStatus: state.store.roomAssistance.popupStatus,
        bgImage: state.store.home.currentDuration.launcherBgImageUrl,
        scrollWid: state.store.home.currentDuration.scrollableWidgets ?
            state.store.home.currentDuration.scrollableWidgets.widgets : [],
        browsersListPopup: state.store.browserListPopup.showPopup,
        screenInfoAfterLoader: state.store.home.screenInfoAfterLoader,
        clientConfig: state.store.home.clientConfig.webAppWidgetsInfo,
        schedules: state.store.home.clientConfig.webAppWidgetsInfo ?
            state.store.home.clientConfig.webAppWidgetsInfo.schedules : {},
        durations: state.store.home.clientConfig.webAppWidgetsInfo ?
            state.store.home.clientConfig.webAppWidgetsInfo.durations : [],
        defaultLayouts: state.store.home.clientConfig.webAppWidgetsInfo ?
            state.store.home.clientConfig.webAppWidgetsInfo.defaultLayout : {},
        MasterWidget: state.store.home.clientConfig.webAppWidgetsInfo ?
            state.store.home.clientConfig.webAppWidgetsInfo.widgetsMaster : {},
        serverTime: state.store.home.serverTimeDate.time,
        serverDay: state.store.home.serverTimeDate.currentDay,
        serverTimeDatePayload: state.store.home.serverTimeDate || {},
        latestCssData: state.store.home.latestCssData,
        currentCSSVersion: state.store.home.currentCSSVersion,
        selectedHomePage: state.store2.currentHomePage,
        latestAppData: state.store.home.latestAppData,
        languagelistData: state.store.home.languagelistData,
        showChatBubble: state.store.showChatBubble,
        guestDetail: state.store.home.guestDetails,
        guestLanguages: state.store.home.guestLanguage.preferredLanguageCode,
        hotelLanguage: state.store.home.hotelLanguages,
        durationId: state.store.home.currentDuration.durationId ?
            state.store.home.currentDuration.durationId : 0,
        layoutText: state.store.home.stringConst,
        durationLang: state.store.home.durationLang,
        faceData: state.store.faceData,
        callFacebookPopup: state.store.callFacebookPopup,
        videoPlayer: state.store.movies.videoPlayer,
        notInHotelPopup: state.store.notInHotelPopup,
        shouldShowCustomPopup:state.store.shouldShowCustomPopup,
        customPopupConfigs:state.store.customPopupConfigs,
        fbLogoutPopup: state.store.logout.status,
        LaodingMass: state.store.LaodingMass,
        acSelected: state.store.acSelected,
        adminDevicePage: state.store.adminDevicePage,
        currentHomePageBeforeNotificationTab: state.store2.currentHomePageBeforeNotificationTab,
        conformationPage: state.store.deviceReg.conformationPage,
        appLauncherWidget: state.store.appLauncher.widget,
        GuestDevReg: state.store.deviceReg.guestRegPag,
        deviceName: state.store.deviceReg.deviceName,
        brandingInfo: state.store.home.currentDuration.brandingInfo.app,
        faqUrl: state.store.home.faqUrl,
        privacyPolicyUrl: state.store.home.privacyPolicyUrl,
        isMobileTV: state.store.home.isMobileTV,
        tncUrl: state.store.home.tncUrl,
        langWidget: state.store.home.langWidget,
        firstTimeOnHome: state.store.home.firstTimeOnHome,
        menuColor: state.store.home.MenuColor,
        confromPage: state.store.confromPage,
        tvConformPage: state.store.tvChannels.conformPage,
        orderDetailPage: state.store.Hcommerce.orderDetailPage,
        guestCheckedOut: state.store.guestCheckedOut,
        guestLoginPage: state.store.guestLoginPage,
        showGuestRequestSubmitPage: state.store.guestRequest.showGuestRequestSubmitPage,
        preloadScreen: state.store.preloadScreen,
        currentWidgetOb: state.store.sideNavBar.currentWidget,
        doorLogin: state.store.doorKey.doorLogin,
        showDoorKeyPage: state.store.doorKey.showDoorKeyPage,
        QRScanPage: state.store.QRScannerPage,
        layoutType: state.store.layoutType,
        clientConfig: state.store.home.clientConfig.extraConfigParam 
        ? state.store.home.clientConfig.extraConfigParam.ENABLE_MULTI_LANGUAGE_SELECTION : "",
        //Store 2
        showHome: state.store2.showHome,
        SelectedNavComponent: state.store.Hcommerce.SelectedNavComponent,
        currentPage: state.store.Hcommerce.currentPage,   
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        installedAppPackageName: state.store.installedAppPackageName,
        showAdminLoginPage: state.store2.showAdminLoginPage,
        showConfirmPopUP: state.store2.confirmaionPopUp.showPopUP,
        guestDeviceLang: state.store2.guestDeviceLang,
        guestPreferedLang: state.store2.guestPreferedLang,
        // showDoorKeyPage: state.store2.doorKey.showDoorKeyPage,
        orderPopUp: state.store2.orderPopUp,
        ckeckOutConfirm: state.store2.viewBill.confirmPop,
        showSucFailPop: state.store2.viewBill.showSucFailPop,
        popUpShow: state.store2.popUpShow,
        goHomeClick: state.store2.goHomeClick,
        // openCheckin: state.store2.openCheckin,
        // openViewBill: state.store2.openViewBill,
        currentHomePage: state.store2.currentHomePage,
        errorPopUP: state.store.doorKey.errorPopUP,
        openRoomDoor:state.store2.openRoomDoor,
        showLoader: state.store2.showLoader,
        loaderMessage: state.store2.loaderMessage,
        showLoaderClose: state.store2.showLoaderClose,
        showSuccessFailPopUp: state.store2.showSuccessFailPopUp,
        showSucFailPop: state.store2.viewBill.showSucFailPop,
        deviceConfigFailed : state.store2.deviceConfigFailed,
        serviceUnavailable : state.store2.serviceUnavailable,
        hvac: state.store.InncomRoomControl.hvac,
        lightScene: state.store.InncomRoomControl.lightScene,
        cameraPermissionGranted: state.store.cameraPermissionGranted,
        curtain: state.store.InncomRoomControl.curtain,
        mobileOverlayState: state.store.mobileOverlayState,
        freshChatData: state.store.freshChatData,
        selectedAC: state.store.InncomRoomControl?
        state.store.InncomRoomControl.selectedAC : [],
        hvac: state.store.InncomRoomControl.hvac,
        showPlaceOrder: state.store2.showPlaceOrder,
        currentWindow: state.store.currentWindow,
        hcommerce_zoom_mapview: state.store.home.clientConfig.extraConfigParam 
        ? state.store.home.clientConfig.extraConfigParam.HCOMMERCE_ZOOM_MAPVIEW : {"zoomLevel" : "20", "mapView" : "k"},
        hcommerceWidget: state.store2.hcommerceWidget,
        subItemListStoreLevel2: state.store.Hcommerce.subItemListStoreLevel2,
        checkinWidgetLaunchTime: state.store2.checkinWidgetLaunchTime,
        storeSku: state.store2.storeSku,
        checkinCurrentPageName: state.store2.checkinCurrentPageName,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        showGuestLogin: state.store.showGuestLogin,
        showNotificationBox: state.store2.showNotificationBox,
        notificationMessage: state.store2.notificationMessage,
        showDoorKeyGuide: state.store2.showDoorKeyGuide,
        showLoginRequired: state.store.showLoginRequired,
        loginRequiredMessage: state.store.loginRequiredMessage,
        hCommerceSavedOrders: state.store.Hcommerce.hCommerceSavedOrders,
        currentZoneStep: state.store.currentZoneStep,
        selectedWindows: state.store.selectedWindows,
        redirectInfo: state.store2.redirectInfo,
        renderHomePage: state.store2.renderHomePage,
        unreadMessageCount: state.store2.unreadMessageCountChat,
        zingleOnInitiated: state.store2.zingleOnInitiated,
        selectedTintLevel: state.store.selectedTintLevel,
        currentTintWindow: state.store.currentTintWindow,
        showWarningPopup: state.store.showWarningPopup,
        openSMSWidgetBool: state.store2.openSMSWidgetBool,
        showBookmarkPopup: state.store2.showBookmarkPopup,
        afterLoginHotelSelectionState: state.store2.afterLoginHotelSelectionState,
        openProfileImage: state.store2.openProfileImage,
        featureNotAvailOnWeb: state.store2.featureNotAvailOnWeb,
        showAdhoc: state.store2.showAdhoc,
        show_itineray_details: state.store2.show_itineray_details,
        footerTabList: getTabs(state.store.home.currentDuration),
        widgetList: state.store2.sideNavBar.widgetList,
        showAutoLoginPopup: state.store2.showAutoLoginPopup,
        queuedCheckInSuccess: state.store2.queuedCheckInSuccess,
        serverTimeDate: state.store.home.serverTimeDate.date,
        digitalKeyInterface: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.digitalKeyInterface ? state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.digitalKeyInterface : false,
        restaurantReservationInterfaceCode: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.restaurantReservationConfigs ? state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.restaurantReservationConfigs.restaurantReservationInterfaceCode : "",
        mobileCheckInDisabled: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.mobileCheckInDisabled ? toBool(state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.mobileCheckInDisabled) : false,
        preCheckInEnabled: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.preCheckInEnabled ? toBool(state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.preCheckInEnabled) : false,
        checkInStartTime: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.checkInStartTime,
        earlyCheckInStartTime: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.earlyCheckInStartTime,
        digitalKeySupportedAuthMethods: state.store2.digitalKeySupportedAuthMethods,
        installedAndroidSDKVersion: state.store.installedAndroidSDKVersion,
        openExternalLinkInSameTab: state.store2.openExternalLinkInSameTab,
        externalSignIn: state.store2.externalSignIn,
        location_data: state.store2.location_data,

    }
}
export default connect(mapStateToProps, { setGoHome, setShowCustomPopup, closeOrderPopUp, sendAnalytics , setExternalSignIn,
    setHotelSelectionAfterLoginState,
    setLoader,
    setShowAutoLoginPopup,
    setCurrentHomePage,
    setCurrentTabNavItemList,
    currentWidget,
    setLoaderClosed,
    popupOpenClose
})(
    withTranslation("translations")(MyStayPage)
);